import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function checkEmployeeGlobalStatus(empId) {
  const response = await axios.get(
    `${API_BASE_URL}/admin/global-recovery/employee-status/${empId}`
  );
  return response.data;
}

export async function releaseEmployeeLockSafely({ empId, cleanedBy, reason }) {
  const response = await axios.post(
    `${API_BASE_URL}/admin/global-recovery/release-employee-lock`,
    {
      empId,
      cleanedBy,
      reason,
    }
  );
  return response.data;
}

export async function checkUserGlobalStatus(userId) {
  const response = await axios.get(
    `${API_BASE_URL}/admin/global-recovery/user-status/${userId}`
  );
  return response.data;
}

export async function releaseUserLockSafely({ userId, cleanedBy, reason }) {
  const response = await axios.post(
    `${API_BASE_URL}/admin/global-recovery/release-user-lock`,
    {
      userId,
      cleanedBy,
      reason,
    }
  );
  return response.data;
}


export async function checkWorkstationGlobalStatus(machineCode) {
  const response = await axios.get(
    `${API_BASE_URL}/admin/global-recovery/workstation-status/${machineCode}`
  );
  return response.data;
}

export async function releaseWorkstationLockSafely({
  machineCode,
  cleanedBy,
  reason,
}) {
  const response = await axios.post(
    `${API_BASE_URL}/admin/global-recovery/release-workstation-lock`,
    {
      machineCode,
      cleanedBy,
      reason,
    }
  );
  return response.data;
}